import * as React from 'react';
import { observable, computed } from "mobx";
import { observer } from "mobx-react";
import { resolve } from "inversify-react";
import autobind from "autobind-decorator";

import { ToastNotifications } from 'src/core/ui/toast';
import { DialogService } from "src/core/services/ui/dialog.service";
import { ControllerProps } from 'src/router';
import { ObjectUtils } from 'src/core/utils/object';
import { LanguageFormView } from "./language-form.view";
import { LanguageDataService } from "./language-form.data";
import { ConfigurationService } from "src/core/services/configuration.service";

interface LanguageFormParams {
	id: string
}

@observer
export class LanguageFormController extends React.Component<ControllerProps<LanguageFormParams>, any>  {
	@resolve
	protected dialogService: DialogService;

	@observable
	protected dataService: LanguageDataService;

	@resolve
	protected toast: ToastNotifications;

	@observable
	mode: ControlMode = 'display';

	@resolve
	protected configurationService: ConfigurationService;

	@observable
	defaultLanguaje: string;

	constructor(props) {
		super(props);
		this.state = {
			refresh: false
		}
		this.dataService = LanguageDataService.make();
	}

	@computed
	protected get title() {
		if (this.dataService && this.dataService.item && this.dataService.item.dynamicProperties.displayName) {
			return `${this.dataService.item.dynamicProperties['displayName'][this.defaultLanguaje]}`;
		}
		return "";
	}

	@autobind
	protected onModeChanged(mode: ControlMode) {
		this.mode = mode;
	}

	@autobind
	protected create() {
		const tax = this.dataService.add(this.defaultLanguaje);
		return tax;
	}
	
	@autobind
	public async save() {
		const item = this.dataService.item;
		const errors = await item.validate(true);
		if (errors.length == 0) {
			this.props.setBusy(true);

			this.dataService.save()
				.then(() => {
					this.props.setBusy(false);
					this.onModeChanged('display');
					this.toast.showDataSaved();
					this.props.history.replace(`/general/language`);
				})
				.catch((error) => {
					this.props.setBusy(false);
					this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
				});
		} else {
			this.toast.showToast('Validation error!', errors.map(e => e.text), 'error');
		}
	}

	@autobind
	public cancel() {
		return new Promise<boolean>((resolve, reject) => {
			if (this.dataService.isDirty) {
				this.dialogService.showYesNo("Warning", "Are you sure want to close this form? Your changes will be lost!")
					.then(dialogResult => {
						if (dialogResult) {
							this.props.history.push("/general/language");
						}
						resolve(true);
					})
					.catch(reject);
			} else {
				this.props.history.push("/general/language");
				resolve(true);
			}
		});
	}

	componentDidMount() {
		this.props.setBusy(true);
		this.configurationService.current()
			.then(res => {
				this.defaultLanguaje = res.defaultLanguage;
				if (this.props.match.params.id == "new") {
					// Create new
					this.dataService.create(this.create)
						.then(() => {
							this.mode = 'edit';

							this.props.setBusy(false);
						}).catch(error => {
							this.props.setBusy(false);
							this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
						});
				} else {
					// Load entity
					this.dataService.addFilter('languageCode', 'eq', this.props.match.params.id);
					this.dataService.addSorting('languageCode', 'asc', true);
					this.dataService.pageSize = 1;
					this.dataService.load(query => query)
						.catch((error) => {
							this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
						})
						.then(() => {
							this.props.setBusy(false);
						});
				}
			});
	}

	render() {
		if (this.dataService == null || this.dataService.item == null) {
			return null;
		}

		return (
			<LanguageFormView title={this.title}
				mode={this.mode}
				onModeChanged={this.onModeChanged}
				cancel={this.cancel}
				save={this.save}
				model={this.dataService.item}
				setBusy={this.props.setBusy}
				onFlagChange={this.onFlagChange}
				contextService={this.dataService}
			/>
		);
	}

	@autobind
	private onFlagChange(ev: React.ChangeEvent<HTMLInputElement>) {
		const file = ev.target.files[0];
		if (file) {
			const contentReader = new FileReader();
			contentReader.onload = (e: Event) => {
				const result: ArrayBuffer = (e.target as any).result;
				this.dataService.item.flag =  new Uint8Array(result);
				this.setState({
					refresh: !this.state.refresh
				});
			};
			contentReader.readAsArrayBuffer(file);
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/general/language/form/language-form.controller.tsx